<template>
    <v-card :loading="loading" :disabled="loading">
        <v-card-title>{{ $t('bestaetigung') }}</v-card-title>
        <v-card-subtitle>Bitte kontrollieren Sie Ihre Angaben nochmals:</v-card-subtitle>
        <v-card-text>
            <v-table v-if="kanton && apollonConfFk && apollonConfFk.length === 1 && rolle">
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <th>
                                {{ $t('kanton') }}
                            </th>
                            <td>
                                <div class="d-flex">
                                    <img :src="kanton.icon || ''" width="24px" class="mr-2" />
                                    {{ kanton.kurz }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {{ $t('foerderkategorie') }}
                            </th>
                            <td>
                                {{ apollonConfFk[0].bezeichnung_apollon }} ({{
                                    apollonConfFk[0].foerderkategorie_gruppe
                                }})
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {{ $t('role') }}
                            </th>
                            <td>
                                {{ rolleDisplay }}
                            </td>
                        </tr>
                        <tr v-if="organisation">
                            <th>
                                {{ $t('organisation') }}
                            </th>
                            <td>
                                {{ orgDisplay }}
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-table>
        </v-card-text>
        <v-card-actions>
            <v-btn
                :disabled="loading"
                variant="flat"
                color="action white--text"
                @click="$emit('back')"
                prepend-icon="fas fa-arrow-left"
            >
                {{ $t('back') }}
            </v-btn>
            <v-btn
                color="action white--text"
                variant="flat"
                :disabled="!kanton || !apollonConfFk || !rolle || loading"
                @click="$emit('create')"
                append-icon="fas fa-check"
            >
                {{ $t('create_gesuch') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="ts">
import type { Adresse, AdresseRolle } from '@/models/Adresse'
import type { ApollonConfFk } from '@/models/ApollonConfFk'
import type { Kanton } from '@/models/Kanton'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const {
    kanton,
    apollonConfFk,
    rolle,
    organisation,
    loading = false,
} = defineProps<{
    kanton: Kanton | null
    apollonConfFk: ApollonConfFk[]
    rolle: AdresseRolle | null
    organisation: Adresse | null
    loading?: boolean
}>()

const { t } = useI18n()

const rolleDisplay = computed(() => {
    if (apollonConfFk && Array.isArray(apollonConfFk) && apollonConfFk.length === 1) {
        return apollonConfFk[0].kontakte?.get(rolle || '').label || (rolle ? t(rolle) : '')
    }
    return ''
})

const orgDisplay = computed(() => {
    if (organisation) {
        return organisation.organisation_name + ', ' + organisation.plz_ort
    }
    return ''
})
</script>
